import React from "react";
import { BOND_PRINCIPAL_KIND } from "../../shared/hooks/useBondPrincipalForm";
import BondPrincipalScreen from "../../shared/components/BondPrincipalScreen";
import { BOND_PRINCIPAL_SHELL_VA_TRUSTEE } from "../../shared/bondWizardStepPropTypes";

const Trustees = ({ data, updateData, globalData, isGuest }) => (
  <BondPrincipalScreen
    kind={BOND_PRINCIPAL_KIND.trustee}
    data={data}
    updateData={updateData}
    globalData={globalData}
    isGuest={isGuest}
  />
);

Trustees.propTypes = BOND_PRINCIPAL_SHELL_VA_TRUSTEE;

export default Trustees;
